import { render, staticRenderFns } from "./monthlyMilkProductionReport.vue?vue&type=template&id=64443b72&scoped=true&"
import script from "./monthlyMilkProductionReport.vue?vue&type=script&lang=js&"
export * from "./monthlyMilkProductionReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64443b72",
  null
  
)

export default component.exports